"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../../../utils/index.js");
var INCA_CLK = 'inca_clk';
var INCA_IMP = 'inca_imp';
var OFFER_CLK = 'offer_clk';
var OFFER_IMP = 'offer_imp';
var offerPrefixes = ['app_offer_', 'web_offer_', 'offer_'];
var getCampaign = function getCampaign(_ref) {
  var internalCampaignName = _ref.internalCampaignName,
    isIncaClicks = _ref.isIncaClicks,
    isIncaImpressions = _ref.isIncaImpressions,
    isOfferClicks = _ref.isOfferClicks,
    isOfferImpressions = _ref.isOfferImpressions,
    offerCode = _ref.offerCode,
    offerOrderType = _ref.offerOrderType,
    offerRanking = _ref.offerRanking,
    ngcOrderItemID = _ref.ngcOrderItemID,
    subscriberPhoneNumber = _ref.subscriberPhoneNumber;
  var promoCode = offerPrefixes.some(function (prefix) {
    return offerCode === null || offerCode === void 0 ? void 0 : offerCode.startsWith(prefix);
  }) ? offerCode : undefined;
  var common = {
    _telus: {
      internalCampaignName: internalCampaignName,
      offerCode: offerCode,
      promoCode: promoCode,
      offerOrderType: offerOrderType,
      offerRanking: offerRanking,
      ngcOrderItemID: ngcOrderItemID,
      subscriberPhoneNumber: subscriberPhoneNumber
    }
  };
  var campaign = {};
  if (isIncaClicks) {
    campaign = {
      SKU: INCA_CLK,
      name: INCA_CLK,
      _telus: {
        campaignClick: 1
      }
    };
  }
  if (isIncaImpressions) {
    campaign = {
      SKU: INCA_IMP,
      name: INCA_IMP,
      _telus: {
        campaignImpression: 1
      }
    };
  }
  if (isOfferClicks) {
    campaign = {
      SKU: OFFER_CLK,
      name: OFFER_CLK,
      _telus: {
        offerClicks: 1
      }
    };
  }
  if (isOfferImpressions) {
    campaign = {
      SKU: OFFER_IMP,
      name: OFFER_IMP,
      _telus: {
        offerImpressions: 1
      }
    };
  }
  return (0, _index.mergeObjects)(common, campaign);
};
var _default = exports["default"] = getCampaign;